<template>
  <div class="single-article-card">
    <div class="riga1">
      <div class="colonna1">
        <a v-if="object.cod_categoria && object.cod_colore" :href="object.link_card"><p>{{ cod_art }}</p></a>
        <a v-else :href="url('/b2b/uncat/' + object.cod_famiglia + '/' + object.slug)"><p>{{ cod_art }}</p></a>
        <p>{{ descrizione }}</p>
      </div>
      <div class="colonna2" v-if="currentRole <= 2">
        <b-field>
          <b-numberinput
              :min="qtaimballo"
              :step="qtaimballo"
              :disabled="!priceFound"
              v-model="currentQuantita"
              type="is-dark"
              :placeholder="$trans('b2b.article.quantity')"
          />
        </b-field>
      </div>
    </div>
    <div class="riga3">
      <p
          :class="
          disponibilita > 0
            ? 'disponibilita available'
            : 'disponibilita unavailable'
        "
          v-if="dispMounted"
      >
        <img
            v-if="disponibilita > 0"
            :src="url('/media/icons/available.svg')"
            :alt="disponibilita"
        />
        <img
            v-if="disponibilita === 0"
            :src="url('/media/icons/unavailable.svg')"
            :alt="disponibilita"
        />

        <span v-if="disponibilita > 0">
          {{ trans.get("b2b.article.availability") }} {{ disponibilita }}
          {{ unitaMisuraLong }}
        </span>
        <span v-if="disponibilita === 0">
          {{ trans.get("b2b.article.availability") }} {{ disponibilita }}
          {{ unitaMisuraLong }}
        </span>
      </p>
    </div>
    <div class="riga2" v-if="currentRole <= 2">
      <div class="colonna1">
        <div class="prezzi">
          <price-elm :cod_art="cod_art" :current_user="currentUser" @prezzi="fetchPrezzi" :unita_misura="unita_misura"
                     @unita-misura="fetchUnitaMisura"/>
        </div>
      </div>
      <div class="colonna2">
        <b-skeleton v-if="!dispMounted && !priceFound" width="215" height="56"></b-skeleton>
        <a class="link-ret green" @click="addToCart" v-if="priceFound">
          {{ trans.get("b2b.article.add-cart") }}
        </a>
        <a class="link-ret disabled" ref="bottone" v-if="!priceFound && dispMounted">
          {{ trans.get("b2b.article.add-cart") }}

        </a>
        <!--        <button class="link-ret disabled" v-if="!dispMounted">-->
        <!--          {{ trans.get("b2b.article.add-cart") }}-->
        <!--        </button>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "single-art-card",
  props: [
    "cod_art",
    "qtaimballo",
    "descrizione",
    "currentRole",
    "currentUser",
    "chiave",
    "unita_misura",
    "object"
  ],
  data: function () {
    return {
      isLoaded: false,
      disponibilita: null,
      dispMounted: false,
      prezzi: null,
      currentQuantita: this.qtaimballo,
      loadingC: false,
      priceFound: false,
      unitaMisura: null,
      unitaMisuraLong: null,
      cardLoaded: false,
      link: null,
    };
  },
  mounted() {
   if(this.cod_art) this.getGiacenza(this.cod_art)

  },
  methods: {
    fetchUnitaMisura(values) {
      this.unitaMisura = values
      if (this.unitaMisura === 'Mt') {
        this.unitaMisuraLong = this.$trans('b2b.prices.meters')
      } else {
        this.unitaMisuraLong = this.$trans('b2b.prices.pieces')
      }

    },
    fetchPrezzi(values) {
      //console.log(values)
      this.priceFound = values.priceFound
      if (values.scaglioni !== null) {
        this.prezzi = values.scaglioni
      }

    },
    addToCart: function () {
      let prezzo = this.prezzi[0].prezzoNetto
      if (this.prezzi.length > 1) {
        length = this.prezzi.length
        if (this.currentQuantita < this.prezzi[length - 2].qta) { // < 99
          prezzo = this.prezzi[0].prezzoNetto
        } else if (this.currentQuantita >= this.prezzi[length - 2].qta && this.currentQuantita < this.prezzi[length - 1].qta) { // >= 100 < 499
          prezzo = this.prezzi[1].prezzoNetto
        } else if (this.currentQuantita >= this.prezzi[length - 1].qta) { // >= 500
          prezzo = this.prezzi[2].prezzoNetto
        }
      }
      this.$store.dispatch("addItemToCart", {
        codart: this.cod_art,
        quantita: this.currentQuantita,
        prezzo: this.currentQuantita * prezzo,
        prezzo_unitario: prezzo,
      });
      //this.$store.dispatch("refreshCart");
      // this.$buefy.toast.open({
      //   message: `Articoli aggiunti correttamente al carrello!`,
      //   duration: 5000,
      //   type: "is-success",
      // });
      this.$store.commit("openCart");
    },
    getPrices: function (codart, user) {
      axios({
        method: "post",
        url: window.location.origin + "/b2b/prezzi",
        params: {
          codart: codart,
          codcliente: user,
        },
      })
          .then((res) => {
            //console.log(res.data[0])
            if (res.data[0].scaglioni.length > 0) {
              this.prezzi = res.data[0].scaglioni;
            } else {
              this.prezzi = [
                {
                  prezzoNetto: 1,
                },
              ];
            }

            this.isLoaded = true;
            //this.$emit('loaded', this.chiave)
          })
          .catch((err) => {
            this.$store.commit("add_message", {
              type: "error",
              message: err.response.data.message,
            });
          });
    },
    getGiacenza: function (codart) {

      axios({
        method: "get",
        url: window.location.origin + "/b2b/giacenze",
        params: {
          codart: codart,
        },
      })
          .then((res) => {
            if (res.data) {
              this.disponibilita = res.data[0].disponibilita;
            }
            this.isLoaded = true;
            this.dispMounted = true;
            this.getUrlAt()
            //this.$emit('cardFinished', this.chiave)
            //this.getPrices(codart, this.currentUser);
          })
          .catch((err) => {
            this.$store.commit("add_message", {
              type: "error",
              message: err.response.data.message,
            });
          });
    },
  },
};
</script>

<style lang="scss" scoped>
.giac {
  width: 100%;
  height: 56px;
}

.loading-button {
  height: 60px;
  width: 60px;
  background-color: transparent;
}

.single-article-card {
  color: #26262a;
  background-color: #f5f5f5;
  padding-left: 52px;
  display: flex;
  flex-direction: column;

  .riga1,
  .riga2,
  .riga3 {
    display: flex;
    justify-content: space-between;
    padding: 18px;

    .colonna1 {
      width: 40%;
      p:first-child {
        text-decoration: underline;
      }
    }

    .colonna2 {
      width: 60%;
    }
  }

  .colonna1,
  .colonna2 {
    display: flex;
    flex-direction: column;
  }

  .riga1 {
    .colonna1 {
      p:first-child {
        margin-bottom: 19px;
      }
    }

    .colonna2 {
    }
  }

  .riga2 {
    .colonna1 {
    }

    .colonna2 {
      a {
        width: 100%;
        height: 56px;
      }
    }
  }

  .riga3 {
    .disponibilita {
      img {
        display: inline-block;
        margin-right: 12px;
      }

      &.available {
        color: #23b371;
      }

      &.unavailable {
        color: #b32323;
      }
    }
  }
}
</style>
